import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 分派类型
 */
class Type extends UltMeta {
    PURCHASE_DEMAND = new Meta(1, "意向");
    PROJECT = new Meta(2, "项目");
    REQUIREMENT_CUSTOMER = new Meta(3, "货主船运");
    REQUIREMENT_PLAT = new Meta(4, "平台船运");
    TRANSPORT_ORDER_SHIP_UPSTREAM = new Meta(5, "船运单-上游");
    TRANSPORT_ORDER_SHIP_DOWNSTREAM = new Meta(6, "船运单-下游");
    MONITOR_EARLY_WARN_RECORD = new Meta(7, "监控预警记录");
}
export const TYPE = new Type();
